<template>
  <div class="notFound">
    <img src="/img/notfound/img-empty-saved.svg" alt="">
    <h4 class="small-title title">Oops, no result found</h4>
    <p class="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p>
    <button class="btn-regular primary">{{button.title}}</button>
  </div>
</template>

<script>
export default {
  name: 'adx-notfound',
  props: {
    title: {
      required: false
    },
    subtitle: {
      required: false
    },
    button: {
      required: false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>